import script from "./TableColumnsConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./TableColumnsConfig.vue?vue&type=script&setup=true&lang=js"

import "./TableColumnsConfig.vue?vue&type=style&index=0&id=cf927cf8&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\53\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf927cf8"]])

export default __exports__